export default "__VITE_ASSET__CwSX92hM__"